/* eslint-disable */

/** unique or primary key constraints on table "argo.material_note" */
export enum ArgoMaterialNoteConstraint {
  /** unique or primary key constraint on columns "material_note_id" */
  MaterialNotePkey = 'material_note_pkey'
}

/** select columns of table "argo.material_note" */
export enum ArgoMaterialNoteSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialNoteId = 'material_note_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.material_note" */
export enum ArgoMaterialNoteUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedLocationId = 'created_location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialNoteId = 'material_note_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status'
}

